<template>
  <div class="info-page">
    <h1 class="page-title">運用者情報</h1>
    <table class="info-table">
      <tbody>
        <tr>
          <th>運用者</th>
          <td>給湯器おすすめ.com 運営事務局（担当：松木）</td>
        </tr>
        <tr>
          <th>住所</th>
          <td>兵庫県神戸市灘区中郷町</td>
        </tr>
        <tr>
          <th>問い合わせ</th>
          <td>navigate.online.store@gmail.com</td>
        </tr>
      </tbody>
    </table>
    <section class="info-section">
      <h2 class="section-title">当サイトについて</h2>
      <p>
        当サイトは、給湯器交換サービスを発信する情報比較サイトになります。<br />
        ※当サイトで掲載する比較表の並び順は給湯器業者の優劣を示すものではありません。
      </p>
    </section>
    <section class="info-section">
      <h2 class="section-title">免責事項</h2>
      <p>
        当サイトに掲載している情報は、給湯器の導入・交換を検討される方への参考情報として提供しているものであり、
        特定の業者やサービスの利用を強制するものではありません。<br /><br />
        掲載内容については正確性・最新性の確保に努めておりますが、その内容を完全に保証するものではありません。<br />
        また、当サイトに掲載されている各給湯器業者のサービス内容、料金、キャンペーン、保証内容等は、各運営会社の判断により変更される場合があります。
        必ずご利用の際は、各業者の公式サイトやお問い合わせ窓口にて最新情報をご確認ください。<br /><br />
        当サイトを通じての業者選定・契約・施工等に関して発生したトラブル、損害、損失について、当サイト運営者は一切の責任を負いかねます。<br />
        また、当サイトに掲載している一部のリンク先はアフィリエイト広告を含む場合がございます。
        リンク先のサービス利用によって発生したいかなる損害についても、当サイト運営者は責任を負いません。
      </p>
    </section>
  </div>
</template>

<script setup>
</script>

<style scoped>
.info-page {
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;
  line-height: 1.8;
  color: #2c3e50;
  text-align: left;
  margin-top: 0;
}

.page-title {
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 30px;
  text-align: center;
  border-bottom: 3px solid #3f51b5;
  display: inline-block;
  padding-bottom: 5px;
  display: block;
  margin-top: 0;
  padding-top: 30px;
}

.info-table {
  max-width: 100%;
  border-collapse: collapse;
  margin-bottom: 40px;
  background: #fafafa;
  border: 1px solid #ddd;
}

.info-table th {
  max-width: 25%;
  text-align: left;
  padding: 12px;
  background: #f0f0f0;
  font-weight: bold;
  border: 1px solid #ddd;
}

.info-table td {
  padding: 12px;
  border: 1px solid #ddd;
}

.section-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 12px;
  color: #3f51b5;
  border-left: 4px solid #3f51b5;
  padding-left: 8px;
}

.info-section {
  margin-bottom: 40px;
}

/* === スマホ調整 === */
@media (max-width: 600px) {
  p {
    font-size: 1rem;
  }

  .info-table {
    font-size: 1rem;
  }

  .section-title {
    font-size: 1.2rem;
  }

  .page-title {
    font-size: 1.6rem
  }
}
</style>
